/* eslint-disable import/extensions */
// eslint-disable-next-line */
/* eslint-disable no-unused-vars */
/* eslint-disable no-new */
import Accordion from 'accordion-js';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules/index.min.mjs';

import 'swiper/swiper-bundle.css';

window.addEventListener( 'cmsContentLoaded', () => {


    const accordionComponent = () => {
        const accordions = Array.from(document.querySelectorAll('.imageAccordion__items'));

        if (!accordions.length) {
            return;
        }
        // Init with options
        window.imageAccordionItems = new Accordion(accordions, {
            duration: 400,
            showMultiple: true,
            elementClass: 'imageAccordionItem',
            triggerClass: 'imageAccordionItem__target',
            panelClass: 'imageAccordionItem__content',
        });
        
    };

    const cardCarouselComponent = () => {
        Swiper.use([Navigation, Pagination]);
        const swiper = new Swiper('.cardCarousel__carousel', {
            // Optional parameters
            slidesPerView: 3,
            slidesPerGroup: 1,
            loop: false,
            spaceBetween: 16,
            grabCursor: true,
            observer: true, 
            observeParents: true,
            // watchOverflow: true,
            // loopFillGroupWithBlank: true,
            centeredSlides: false,
            // If we need pagination
            pagination: {
                el: '.cardCarousel-swiper-pagination',
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: 'button.cardCarousel-swiper-button-next',
                prevEl: 'button.cardCarousel-swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 280px
                280: {
                    slidesPerView: 1,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                },
                // when window width is >= 1200x
                1200: {
                    slidesPerView: 3,
                }
            }
        });
        swiper.on('slideChange',() => {
            swiper.pagination.render();
            swiper.pagination.update();
        });
    };

    const photoCarouselComponent = () => {
        Swiper.use([Navigation, Pagination]);
        const swiper = new Swiper('.photoCarousel__carousel', {
            // Optional parameters
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            spaceBetween: 16,
            grabCursor: true,
            observer: true, 
            observeParents: true,
            // watchOverflow: true,
            // loopFillGroupWithBlank: true,
            centeredSlides: false,
            // If we need pagination
            pagination: {
                el: '.photoCarousel-swiper-pagination',
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: 'button.photoCarousel-swiper-button-next',
                prevEl: 'button.photoCarousel-swiper-button-prev',
            },
        });
        swiper.on('slideChange',() => {
            swiper.pagination.render();
            swiper.pagination.update();
        });
    };

    const testimonialsCarouselComponent = () => {
        Swiper.use([Navigation, Pagination]);
        const swiper = new Swiper('.testimonialsCarousel__carousel', {
            // Optional parameters
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            spaceBetween: 16,
            grabCursor: true,
            observer: true, 
            observeParents: true,
            // watchOverflow: true,
            // loopFillGroupWithBlank: true,
            centeredSlides: false,
            // If we need pagination
            pagination: {
                el: '.testimonialsCarousel-swiper-pagination',
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: 'button.testimonialsCarousel-swiper-button-next',
                prevEl: 'button.testimonialsCarousel-swiper-button-prev',
            },
        });
        swiper.on('slideChange',() => {
            swiper.pagination.render();
            swiper.pagination.update();
        });
    };

    accordionComponent();
    cardCarouselComponent();
    photoCarouselComponent();
    testimonialsCarouselComponent();
});



// WEBPACK FOOTER //
// ./frontend/site.js